import { useState } from "react";
import { customersApi } from "../services/customersService";
import { useAsyncFn } from "./useAsync";
import { useAxiosPrivate } from "./useAxiosPrivate";
import useDebounce from "./useDebouce";

import { isEmptyArray } from "../helpers/methods";

const MIN_PHONE_LENGTH_TO_SEARCH_CUSTOMERS = 9;

const useFoundCustomersByParams = ({ personEmails, personPhones }) => {
  const axiosPrivate = useAxiosPrivate();

  const [customersFoundedByEmail, setCustomersFoundedByEmail] = useState(null);
  const getCustomersByEmailFn = useAsyncFn(() => {
    let validEmails = personEmails.filter((email) => email?.includes("@"));
    if (isEmptyArray(validEmails)) {
      return Promise.resolve({});
    }

    const params = new URLSearchParams();
    params.append("customer_type", "person");
    for (let email of validEmails) {
      params.append("emails", email);
    }
    return customersApi.getCustomers(axiosPrivate, params);
  }, [personEmails]);

  useDebounce(
    () =>
      getCustomersByEmailFn
        .execute()
        .then((res) => setCustomersFoundedByEmail(res.results || null)),
    1000,
    [personEmails],
  );

  const [customersFoundedByPhone, setCustomersFoundedByPhone] = useState(null);
  const getCustomersByPhoneFn = useAsyncFn(() => {
    let validPhones = personPhones.filter(
      (phone) => phone && phone.length >= MIN_PHONE_LENGTH_TO_SEARCH_CUSTOMERS,
    );
    if (isEmptyArray(validPhones)) {
      return Promise.resolve({});
    }

    const params = new URLSearchParams();
    params.append("customer_type", "person");
    for (let phone of validPhones) {
      params.append("phones", phone);
    }
    return customersApi.getCustomers(axiosPrivate, params);
  }, [personPhones]);

  useDebounce(
    () =>
      getCustomersByPhoneFn
        .execute()
        .then((res) => setCustomersFoundedByPhone(res.results || null)),
    1000,
    [personPhones],
  );

  return { customersFoundedByEmail, customersFoundedByPhone };
};

// for single phone, email
// const useFoundCustomersByParams = ({ personEmail, personPhone }) => {
//     const axiosPrivate = useAxiosPrivate();

//     const [customersFoundedByEmail, setCustomersFoundedByEmail] = useState(null);
//     const getCustomersByEmailFn = useAsyncFn(() => {
//         if (personEmail?.includes("@")) {
//             const params = new URLSearchParams();
//             params.append("email", personEmail);
//             params.append("customer_type", "person");
//             return customersApi.getCustomers(axiosPrivate, params);
//         }

//         return Promise.resolve({});
//     }, [personEmail]);

//     useDebounce(
//         () =>
//             getCustomersByEmailFn
//                 .execute()
//                 .then((res) => setCustomersFoundedByEmail(res.results || null)),
//         1000,
//         [personEmail],
//     );

//     const [customersFoundedByPhone, setCustomersFoundedByPhone] = useState(null);
//     const getCustomersByPhoneFn = useAsyncFn(() => {
//         if (personPhone && personPhone.length >= MIN_PHONE_LENGTH_TO_SEARCH_CUSTOMERS) {
//             const params = new URLSearchParams();
//             params.append("phone", personPhone);
//             params.append("customer_type", "person");
//             return customersApi.getCustomers(axiosPrivate, params);
//         }

//         return Promise.resolve({});
//     }, [personPhone]);

//     useDebounce(
//         () =>
//             getCustomersByPhoneFn
//                 .execute()
//                 .then((res) => setCustomersFoundedByPhone(res.results || null)),
//         1000,
//         [personPhone],
//     );

//     return { customersFoundedByEmail, customersFoundedByPhone };
// };

export default useFoundCustomersByParams;
